export const MINT_PRICE_IN_ETH = 0.05;
export const CONTRACT_ADDRESS = "0x1ffBE63cDAa0421e39D1D849cd8a14fC440feA65";
export const NETWORK_ID = 56;
export const NETWORK_NAME ="BSC Mainnet";
export const MINTING_STARTED = true;
